import { IApiSmpGptAgent } from "@smp/api";

export interface ICreateFormProps {
  onSuccess: (agent: IApiSmpGptAgent) => void;
  onChangeStep: (step: number | undefined) => void;
  onChangeState: (state: "submitting" | "idle") => void;
}

export interface ICreateFormValues {
  projectId?: number;
  middleData: {
    occupation: string;
    target_audience: string;
    problem: string;
  };
  context: {
    niche: string;
    occupation: string;
    target_audience: string;
    problem: string;
    usp: string;
    benefits: string;
    goal: string;
    key_messages: string;
    avoided_topics: string;
    sample: string;
  };
  post: {
    text_length: string;
    text_style: string[];
    extra_fields: string[];
    frameworks: string[];
    num: number;
    language: string;
    topic: string;
  };
}

export enum EStep {
  OCCUPATION,
  TARGET_AUDIENCE,
  PROBLEM,
  CONFIRMATION,
}
